import React from "react";
import "../../css/HomePage.css";
import "../../css/BackgroundSections.css";
import "../../css/GraphicSection.css";
import LandingPageHero from "../components/parents/LandingPageHero";
import WhyChooseUs from "../components/parents/WhyChooseUs";
import PlanForParents from "../components/parents/PlanForParents";
import ParentGraphic from "../components/parents/ParentGraphic";
import OurMission from "../components/parents/OurMissionParents";
import ContactUs from "../components/ContactUs";
import WhyThisMatters from "../components/parents/WhyThisMatters";

const ParentsPage = () => {
  return (
    <>
      <div id="home">
        <LandingPageHero />
      </div>

      <div id="services">
        <PlanForParents />
      </div>
      <WhyThisMatters/>

      <ParentGraphic />

      <div id="why-choose-us">
        <WhyChooseUs />
      </div>

      <div id="mission">
        <OurMission />
      </div>
      <div id="contact">
        <ContactUs />
      </div>
    </>
  );
};

export default ParentsPage;
